import { render, staticRenderFns } from "./EditCheckBox3.vue?vue&type=template&id=08ff95da&scoped=true"
import script from "./EditCheckBox3.vue?vue&type=script&lang=ts"
export * from "./EditCheckBox3.vue?vue&type=script&lang=ts"
import style0 from "./EditCheckBox3.vue?vue&type=style&index=0&id=08ff95da&prod&scoped=true&lang=css"
import style1 from "./EditCheckBox3.vue?vue&type=style&index=1&id=08ff95da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff95da",
  null
  
)

export default component.exports